import collision from '@/assets/generated/world/coast/coast-collision.json';
import zones from '@/assets/generated/world/coast/coast-zones.json';
import { translatedRegionData, type SerializedMapData, type SerializedZoneData } from './region-map-data';

const data = translatedRegionData(
  collision as unknown as SerializedMapData,
  zones as unknown as SerializedZoneData,
  2560,
  1920,
  2,
);
export const COAST_COLLISION = data.collision;
export const COAST_ZONES = data.zones;
